import React from "react";
import { useNavigate } from "react-router-dom";

const departments = [
  { name: "Medical", color: "#228be6", count: 12 },
  { name: "Nursing", color: "#43ba7f", count: 18 },
  { name: "Administration", color: "#ffd43b", count: 8 },
  { name: "Laboratory", color: "#ffa94d", count: 5 },
  { name: "Pharmacy", color: "#845ef7", count: 4 },
  { name: "Radiology", color: "#868e96", count: 3 },
  { name: "Therapy", color: "#5c7cfa", count: 6 },
  { name: "Support", color: "#15aabf", count: 7 },
];

export default function StaffDepartments() {
  const navigate=useNavigate();
  return (
    <div className="departments-col" style={{
      background:"#fff", borderRadius:"12px", boxShadow:"0 2px 16px #eee",
      padding:"20px 24px", marginBottom:"0"
    }}>
      <h5 className="h5" style={{marginBottom:10}}>Departments</h5>
      <ul style={{listStyle:'none',padding:0,margin:0}}>
        {departments.map(dep=>(
          <li key={dep.name} className="department-row" style={{marginBottom:"9px"}}>
            <span className="department-col department-dot" style={{
              display:'inline-block',width:10,height:10,
              borderRadius:'50%',background:dep.color,marginRight:8,marginBottom:-2
            }}></span>
            {dep.name}
            <span className="department-col department-count" style={{
              float:"right",color:"#888"
            }}>{dep.count}</span>
          </li>
        ))}
      </ul>
      <button className="gradient-dark-button" onClick={()=>navigate("/Departments")} style={{
        width:"100%",textAlign:"center",fontSize:"14px",cursor:"pointer"
      }}>
        Manage Departments
      </button>
    </div>
  );
}
